import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'

const Meta = props => {
  useEffect(() => {
    if (document) {
      var tagjs = document.createElement('script')
      var s = document.getElementsByTagName('script')[0]
      tagjs.async = true
      tagjs.src = '//s.yjtag.jp/tag.js#site=LfbTQk1'
      s.parentNode.insertBefore(tagjs, s)
    }
  }, [])

  const dir_name = props.dir_name
  const title = props.title
    ? props.title
    : 'CalorieMate to Programmer | 大塚製薬'
  const description = props.description
    ? props.description
    : 'カロリーメイトから、すべてのうちこむ人へ。プログラミング言語で書かれたメッセージを公開中。　#うちこむ人にバランス栄養'
  const base = 'https://www.otsuka.co.jp/cmt/to_programmer/'
  // const base = 'https://otsuka.preview.i-studio.co.jp/cmt/to_programmer/'
  const og_url = `${base}`
  const og_image = `${base}assets/img/og/topv2.png`

  const sns_title = title
  const sns_description = description

  let src_font = ''
  let src_ga = ''

  const bodyClass = props.bodyClass ? props.bodyClass : ''

  src_font = (
    <script
      src="//typesquare.com/3/tsst/script/ja/typesquare.js?5efafdf2e53c4807b1a16d5cac1e0217"
      charset="utf-8"
    ></script>
  )

  if (props.isLoadSrc !== '') {
    src_ga = (
      <script>{`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PFCFBJ');
      `}</script>
    )
  }

  return (
    <Helmet>
      <htmlAttributes />
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, user-scalable=no"
      />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={sns_title} />
      <meta property="og:description" content={sns_description} />
      <meta property="og:url" content={og_url} />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={og_image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={sns_title} />
      <meta name="twitter:description" content={sns_description} />
      <script>
        {`      
        if (!Element.prototype.matches) {
          Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                      Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
          Element.prototype.closest = function(s) {
            var el = this;

            do {
              if (el.matches(s)) return el;
              el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
          };
        }

        var userAgent = window.navigator.userAgent.toLowerCase();
        if(userAgent.indexOf('trident') != -1) {
          window.is_Effect = false
          window.is_IE = true
        }else{
          window.is_Effect = true
          window.is_IE = false
        }
`}
      </script>
      {src_font}
      {src_ga}
      <script src="https://polyfill.io/v2/polyfill.min.js?features=IntersectionObserver"></script>

      <bodyAttributes className={bodyClass} />
    </Helmet>
  )
}

export default Meta
